import { Link } from "react-router-dom";

export default function Logo({ compact = false }) {
  return (
    <Link
      to="/"
      data-testid="site-logo"
      className="group inline-flex items-center gap-2.5"
    >
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-md border border-cyan-500/50 bg-slate-100">
        <span className="absolute inset-0 rounded-md bg-cyan-600/10 blur-md transition-opacity duration-300 group-hover:opacity-80" />
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M3 7l9-5 9 5v10l-9 5-9-5V7z"
            stroke="#22d3ee"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path
            d="M12 2v20M3 7l18 10M21 7L3 17"
            stroke="#22d3ee"
            strokeOpacity=".45"
            strokeWidth="1"
          />
        </svg>
      </span>
      <div className="leading-none">
        <div className="font-heading text-[15px] font-bold tracking-wide text-slate-900">
          GTECGLOBAL
        </div>
        {!compact && (
          <div className="font-mono text-[10px] tracking-[0.28em] text-cyan-600">
            COMPUTERS · FZCO
          </div>
        )}
      </div>
    </Link>
  );
}
